function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { updateContact } from "./voyado";
import { updateCart } from "../shop/render";
import { destroySelection } from "../shop/connect";
var geTrackingTimeout = null;
var geTracking = function geTracking() {
  console.log(typeof glegem === "undefined" ? "undefined" : _typeof(glegem));
  if (typeof glegem === 'undefined') {
    geTrackingTimeout = setTimeout(getTracking, 100);
    console.log('waiting for glegem...');
    return;
  }
  ;
  clearTimeout(geTrackingTimeout);
  glegem("OnCheckoutStepLoaded", function (data) {
    console.log(data);
    switch (data.StepId) {
      case data.Steps.LOADED:
        gaCheckout(data);
        break;
      case data.Steps.CONFIRMATION:
        if (data.IsSuccess) {
          destroyCartSelection();
          gaPurchase(data);
          sendVoyadoPurchase(data);
          updateTrustpilot(data);
        }
        break;
    }
  });
};
var getAddressDetails = function getAddressDetails(data) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Billing";
  var customerDetails = data.details.CustomerDetails || {};
  var addressDetails = customerDetails["".concat(type, "Address")] || {};
  return {
    email: addressDetails["".concat(type, "Email")] || null,
    firstName: addressDetails["".concat(type, "FirstName")] || null,
    lastName: addressDetails["".concat(type, "LastName")] || null,
    company: addressDetails["".concat(type, "Company")] || null,
    address1: addressDetails["".concat(type, "Address1")] || null,
    address2: addressDetails["".concat(type, "Address2")] || null,
    zipCode: addressDetails["".concat(type, "ZipCode")] || null,
    city: addressDetails["".concat(type, "City")] || null,
    state: addressDetails["".concat(type, "StateCode")] || null,
    country: addressDetails["".concat(type, "CountryCode")] || null,
    countryName: addressDetails["".concat(type, "CountryName")] || null,
    phoneNumber: addressDetails["".concat(type, "PhoneNumber")] || null
  };
};
var updateTrustpilot = function updateTrustpilot(data) {
  var orderDetails = {
    id: data.details.OrderID,
    address: getAddressDetails(data),
    shippingAddress: getAddressDetails(data, "Shipping")
  };
  createTpInvitation(orderDetails || {});
};
var sendVoyadoPurchase = function sendVoyadoPurchase(data) {
  var isNewsletterChecked = data.details.AllowMailsFromMerchant || false;
  var toSendData = {
    order: {
      address: getAddressDetails(data),
      shippingAddress: getAddressDetails(data, "Shipping")
    }
  };
  updateContact(toSendData, isNewsletterChecked);
};
var pushDataToDatalayer = function pushDataToDatalayer(data) {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push(data);
};
var extractDatalayerProductData = function extractDatalayerProductData(item, includeTax) {
  var metadata = {};
  if (item.MetaData) {
    item.MetaData.forEach(function (metaAttribute) {
      metadata[metaAttribute.AttributeKey] = metaAttribute.AttributeValue;
    });
  }
  var formattedId = "".concat(STOKED.GTM.siteId, "/").concat(STOKED.GTM.country, "-p").concat(metadata._Centra_Product, "-v").concat(metadata._Centra_Variant, "-s");
  return {
    name: item.ProductName,
    id: metadata.VariantSku || "",
    price: includeTax ? item.ProductPrices.CustomerTransactionInMerchantCurrency.CustomerDiscountedPriceInMerchantCurrency : item.ProductPrices.MerchantTransactionExcludingLocalVAT.DiscountedPriceExcludingVAT,
    brand: metadata.Brand || STOKED.siteName,
    category: metadata.Category || "",
    variant: metadata.Variant || "",
    quantity: parseInt(item.Quantity || 0),
    dimension1: formattedId,
    dimension2: metadata.VariantSku || "",
    dimension3: item.SKU || ""
  };
};

// Send GA on Checkout
var gaCheckout = function gaCheckout(data) {
  var gaData = {
    event: "checkout",
    ecommerce: {
      checkout: {
        products: data.details.ProductInformation.map(function (item) {
          return extractDatalayerProductData(item, STOKED.GTM.includeTax);
        })
      },
      currencyCode: data.details.MerchantCurrencyCode
    }
  };
  pushDataToDatalayer(gaData);
};

// Send GA on Purchase
var gaPurchase = function gaPurchase(data) {
  // Voucher
  var voucher = "";
  if (data.details.Discounts) {
    var discountVouchers = data.details.Discounts.filter(function (discount) {
      return discount.DiscountCode;
    }).map(function (discount) {
      return discount.DiscountCode;
    });
    voucher = discountVouchers.filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).join(", ");
  }
  var gaData = {
    event: "purchase",
    ecommerce: {
      purchase: {
        actionField: {
          id: data.details.OrderID,
          affiliation: STOKED.siteName,
          revenue: STOKED.GTM.includeTax ? data.details.OrderPrices.CustomerTransactionInMerchantCurrency.CustomerTotalDiscountedProductsPriceInMerchantCurrency : data.details.OrderPrices.CustomerTransactionInMerchantCurrency.CustomerTotalDiscountedProductsPriceInMerchantCurrency - data.details.OrderPrices.CustomerTransactionInMerchantCurrency.CustomerVATInMerchantCurrency,
          tax: data.details.OrderPrices.CustomerTransactionInMerchantCurrency.CustomerVATInMerchantCurrency,
          shipping: data.details.OrderPrices.CustomerTransactionInMerchantCurrency.CustomerShippingPriceInMerchantCurrency,
          coupon: voucher
        },
        products: data.details.ProductInformation.map(function (item) {
          return extractDatalayerProductData(item, STOKED.GTM.includeTax);
        })
      },
      currencyCode: data.details.MerchantCurrencyCode
    }
  };
  pushDataToDatalayer(gaData);
};
var destroyCartSelection = function destroyCartSelection() {
  console.log('destroy selection');
  destroySelection();
  updateCart({
    items: [],
    totals: {
      totalQuantity: 0,
      itemsTotalPrice: 0,
      shippingPrice: 0,
      grandTotalPrice: 0
    }
  }, null, null);
};
export default geTracking;


// WEBPACK FOOTER //
// ./scripts/components/ge-tracking.js